import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useCurrentUserRole } from "../hooks/useCurrentUserRole";
import { mayConfigurePaymentIntegration } from "../lib/tenantUserAccess";

/** Betaalproviderinstellingen zijn uitsluitend voor tenant_admin of supervisor. */
export function PaymentIntegrationRoute() {
  const { session, loading: authLoading } = useAuth();
  const actorId = session?.user?.id;
  const { role, isLoading: roleLoading, isError: roleError } = useCurrentUserRole(actorId);

  if (authLoading || roleLoading) {
    return <div className="flex min-h-[40vh] items-center justify-center text-sm text-gray-500">Toegang controleren…</div>;
  }
  if (roleError || !mayConfigurePaymentIntegration(role)) {
    return <Navigate to="/app/integraties" replace />;
  }
  return <Outlet />;
}
